import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaterBodiesRoutingModule } from './water-bodies-routing.module';
import { FormsModule } from '@angular/forms';
import { WaterBodiesResolve } from './water-bodies.resolve';
import { SharedModule } from '../../../shared/shared.module';
import { AppMaterialModule } from '../../../shared/appMaterial/app-material.module';
import { WaterBodiesComponent } from './water-bodies.component';
import { WaterBodiesFormModule } from './form/water-bodies-form.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [
    CommonModule,
    WaterBodiesRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    WaterBodiesFormModule,
    ListGridModule,
  ],
  declarations: [WaterBodiesComponent],
  exports: [WaterBodiesComponent],
  providers: [WaterBodiesResolve],
})
export class WaterBodiesModule {}
